import { useEffect, useRef } from 'react'

export const useWindowResize = (callback, delay = 500) => {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    let resizeTimeout
    let animationFrame

    const handleResize = () => {
      clearTimeout(resizeTimeout)
      cancelAnimationFrame(animationFrame)

      resizeTimeout = setTimeout(() => {
        animationFrame = requestAnimationFrame(() => {
          callbackRef.current()
        })
      }, delay)
    }

    window.addEventListener('resize', handleResize)
    window.visualViewport.addEventListener('resize', handleResize)

    return () => {
      clearTimeout(resizeTimeout)
      cancelAnimationFrame(animationFrame)
      window.removeEventListener('resize', handleResize)
      window.visualViewport.removeEventListener('resize', handleResize)
    }
  }, [delay])
}
